import { mergeAttributes } from '@tiptap/core';
import type { DOMOutputSpec } from '@tiptap/pm/model';

// Schema shared by the two section node extensions: vMarkdown's (editor UX —
// input rules, keyboard handlers, node view, EHR guard) and markdown-native's
// (markdown parse/serialize). The systems share no other code; both spread
// this fragment so the node name, content model, attrs, and HTML rules can't
// drift apart.
export const sectionNodeSchemaSpec = {
  name: 'sectionNode',
  group: 'block',
  content: 'block+',
  isolating: true,

  addAttributes() {
    return {
      sectionTitle: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-section-title'),
        renderHTML: (attributes: Record<string, string>) => {
          if (!attributes.sectionTitle) return {};
          return { 'data-section-title': attributes.sectionTitle };
        },
      },
      isDraftSection: {
        default: false,
        parseHTML: (element: HTMLElement) =>
          element.getAttribute('data-draft-section') === 'true',
        renderHTML: (attributes: Record<string, boolean>) => {
          if (!attributes.isDraftSection) return {};
          return { 'data-draft-section': 'true' };
        },
      },
      linkedEhrSectionId: {
        default: null,
        parseHTML: (element: HTMLElement) =>
          element.getAttribute('data-linked-ehr-section-id'),
        renderHTML: (attributes: Record<string, string | null>) => {
          if (!attributes.linkedEhrSectionId) return {};
          return { 'data-linked-ehr-section-id': attributes.linkedEhrSectionId };
        },
      },
    };
  },

  parseHTML() {
    return [{ tag: 'section[data-section-title]' }];
  },

  renderHTML({
    HTMLAttributes,
  }: {
    HTMLAttributes: Record<string, unknown>;
  }): DOMOutputSpec {
    return ['section', mergeAttributes(HTMLAttributes), 0];
  },
};
